// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.empty-view {
  height: 100%;
}
.empty-view__column {
  max-width: 600px;
}
.empty-view__icon {
  width: 100%;
}
.empty-view--isTwoColumns .empty-view__column:last-child:not(:first-child) {
  margin-left: 32px;
  min-height: 0;
  max-height: 100%;
}
.empty-view__icon-backdrop {
  background-color: var(--color-neutral-background-subdued);
  color: var(--color-content-secondary);
  border-radius: 32px;
  height: 64px;
  width: 64px;
}
.empty-view__action-link--variant-basic {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-base);
  box-shadow: 0 0 0 1px var(--color-border-base);
}
.empty-view__action-link--variant-basic .v-icon {
  color: var(--color-icon-base);
}
.empty-view__action-link--variant-basic:hover {
  color: var(--color-content-base);
  background-color: var(--color-neutral-background-hover);
}
.empty-view__action-link--variant-basic:hover .v-icon {
  color: var(--color-icon-base);
}
.empty-view__action-link--variant-basic:active {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-basic:active .v-icon {
  color: var(--color-icon-base);
}
.empty-view__action-link--variant-basic.n--pressed {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-basic.n--pressed .v-icon {
  color: var(--color-icon-base);
}
.empty-view__action-link--variant-basic.n--pressed:hover {
  color: var(--color-content-base);
  background-color: oklch(from var(--color-neutral-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-basic.n--pressed:hover .v-icon {
  color: var(--color-icon-base);
}
.empty-view__action-link--variant-basic.n--disabled,
.empty-view__action-link--variant-basic.n--disabled:hover,
.empty-view__action-link--variant-basic.n--disabled:active,
.empty-view__action-link--variant-basic.n--disabled.n--pressed {
  color: oklch(from var(--color-content-base) l c h / 0.5);
  background-color: var(--color-neutral-background-base);
}
.empty-view__action-link--variant-basic.n--disabled .v-icon,
.empty-view__action-link--variant-basic.n--disabled:hover .v-icon,
.empty-view__action-link--variant-basic.n--disabled:active .v-icon,
.empty-view__action-link--variant-basic.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-icon-base) l c h / 0.5);
}
.empty-view__action-link--variant-primary {
  color: var(--color-content-white);
  background-color: var(--color-accent-background-base);
}
.empty-view__action-link--variant-primary .v-icon {
  color: var(--color-content-white);
}
.empty-view__action-link--variant-primary:hover {
  color: var(--color-content-white);
  background-color: var(--color-accent-background-hover);
}
.empty-view__action-link--variant-primary:hover .v-icon {
  color: var(--color-content-white);
}
.empty-view__action-link--variant-primary:active {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-primary:active .v-icon {
  color: var(--color-content-white);
}
.empty-view__action-link--variant-primary.n--pressed {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-primary.n--pressed .v-icon {
  color: var(--color-content-white);
}
.empty-view__action-link--variant-primary.n--pressed:hover {
  color: var(--color-content-white);
  background-color: oklch(from var(--color-accent-background-hover) l c h / 0.97);
}
.empty-view__action-link--variant-primary.n--pressed:hover .v-icon {
  color: var(--color-content-white);
}
.empty-view__action-link--variant-primary.n--disabled,
.empty-view__action-link--variant-primary.n--disabled:hover,
.empty-view__action-link--variant-primary.n--disabled:active,
.empty-view__action-link--variant-primary.n--disabled.n--pressed {
  color: oklch(from var(--color-content-white) l c h / 0.7);
  background-color: oklch(from var(--color-accent-background-base) l calc(c * 0.5) h / 0.8);
}
.empty-view__action-link--variant-primary.n--disabled .v-icon,
.empty-view__action-link--variant-primary.n--disabled:hover .v-icon,
.empty-view__action-link--variant-primary.n--disabled:active .v-icon,
.empty-view__action-link--variant-primary.n--disabled.n--pressed .v-icon {
  color: oklch(from var(--color-content-white) l c h / 0.7);
}
.empty-view__action-link:hover {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/empty-view/EmptyView.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/button.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,YAAA;AASF;AAPE;EACE,gBAAA;AASJ;AANE;EACE,WAAA;AAQJ;AALE;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;AAOJ;AAJE;EACE,yDAAA;EACA,qCAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAMJ;AAFI;EC1BA,gCAAA;EACA,sDAAA;EAiEF,8CAAA;ADjCF;AC/BI;EACE,6BAAA;ADiCN;ACzBE;EAXE,gCAAA;EACA,uDAAA;ADuCJ;ACtCI;EACE,6BAAA;ADwCN;AC5BE;EAfE,gCAAA;EACA,gFAAA;AD8CJ;AC7CI;EACE,6BAAA;AD+CN;AC/BE;EAnBE,gCAAA;EACA,gFAAA;ADqDJ;ACpDI;EACE,6BAAA;ADsDN;ACnCI;EAtBA,gCAAA;EACA,gFAAA;AD4DJ;AC3DI;EACE,6BAAA;AD6DN;ACpCI;;;;EA5BA,wDAAA;EACA,sDAAA;ADsEJ;ACrEI;;;;EACE,qDAAA;AD0EN;AA/CI;EC9BA,iCAAA;EACA,qDAAA;ADgFJ;AC/EI;EACE,iCAAA;ADiFN;ACzEE;EAXE,iCAAA;EACA,sDAAA;ADuFJ;ACtFI;EACE,iCAAA;ADwFN;AC5EE;EAfE,iCAAA;EACA,+EAAA;AD8FJ;AC7FI;EACE,iCAAA;AD+FN;AC/EE;EAnBE,iCAAA;EACA,+EAAA;ADqGJ;ACpGI;EACE,iCAAA;ADsGN;ACnFI;EAtBA,iCAAA;EACA,+EAAA;AD4GJ;AC3GI;EACE,iCAAA;AD6GN;ACpFI;;;;EA5BA,yDAAA;EACA,yFAAA;ADsHJ;ACrHI;;;;EACE,yDAAA;AD0HN;AA3FI;EACE,qBAAA;AA6FN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.empty-view {\n  height: 100%;\n\n  &__column {\n    max-width: 600px;\n  }\n\n  &__icon {\n    width: 100%;\n  }\n\n  &--isTwoColumns &__column:last-child:not(:first-child) {\n    margin-left: @layoutUnit-xl;\n    min-height: 0;\n    max-height: 100%;\n  }\n\n  &__icon-backdrop {\n    background-color: var(--color-neutral-background-subdued);\n    color: var(--color-content-secondary);\n    border-radius: @layoutUnit-xl;\n    height: 2 * @layoutUnit-xl;\n    width: 2 * @layoutUnit-xl;\n  }\n\n  &__action-link {\n    &--variant-basic {\n      .button-variant-default();\n    }\n\n    &--variant-primary {\n      .button-variant-primary();\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n",".button-variant(@normal; @normal-hover; @pressed; @pressed-hover; @disabled) {\n  .set-colors(@colors) {\n    color: extract(@colors, 1);\n    background-color: extract(@colors, 2);\n    & .v-icon {\n      color: extract(@colors, 3);;\n    }\n  }\n\n  & {\n    .set-colors(@normal);\n  }\n\n  &:hover {\n    .set-colors(@normal-hover);\n  }\n\n  &:active {\n    .set-colors(@pressed);\n  }\n\n  &.n--pressed {\n    .set-colors(@pressed);\n\n    &:hover {\n      .set-colors(@pressed-hover);\n    }\n  }\n\n  &.n--disabled {\n    &,\n    &:hover,\n    &:active,\n    &.n--pressed {\n      .set-colors(@disabled);\n    }\n  }\n}\n\n.button-variant-primary() {\n  @text: var(--color-content-white);\n  @icon: var(--color-content-white);\n  @background: var(--color-accent-background-base);\n  @background-hover: var(--color-accent-background-hover);\n  @background-pressed: oklch(from var(--color-accent-background-hover) l c h / 0.97);\n\n  .button-variant(@text, @background, @icon;                                                                   // normal (fg, bg, icon)\n    @text, @background-hover, @icon;                                                                           // normal:hover\n    @text, @background-pressed, @icon;                                                                         // pressed\n    @text, @background-pressed, @icon;                                                                         // pressed:hover\n    oklch(from @text l c h / 0.7), oklch(from @background l calc(~\"c * 0.5\") h / 0.8), oklch(from @icon l c h / 0.7) // disabled\n  );\n}\n\n.button-variant-default() {\n  @text: var(--color-content-base);\n  @icon: var(--color-icon-base);\n  @background: var(--color-neutral-background-base);\n  @background-hover: var(--color-neutral-background-hover);\n  @background-pressed: oklch(from var(--color-neutral-background-hover) l c h / 0.97);\n\n  .button-variant(@text, @background, @icon;                              // normal (fg, bg, icon)\n    @text, @background-hover, @icon;                                      // hover\n    @text, @background-pressed, @icon;                                    // pressed\n    @text, @background-pressed, @icon;                                    // pressed:hover\n    oklch(from @text l c h / 0.5), @background, oklch(from @icon l c h / 0.5) // disabled\n  );\n\n  box-shadow: 0 0 0 1px var(--color-border-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
